import { Scroll } from "./scroll";

export function runEmbedScripts(container: HTMLElement) {
  const embeds = container.querySelectorAll(".w-embed");

  let cleanup = Array.from(embeds, (embed) => {
    embed.querySelectorAll("script").forEach((original) => {
      const fresh = document.createElement("script");
      [...original.attributes].forEach((attr) => {
        fresh.setAttribute(attr.name, attr.value);
      });
      fresh.textContent = original.textContent;
      original.parentNode!.replaceChild(fresh, original);
    });

    const observer = new MutationObserver(() => Scroll.resize());
    observer.observe(embed, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    return () => observer.disconnect();
  });

  return function cleanupAll() {
    cleanup.forEach((e) => {
      e();
    });
  };
}
